import { useTranslation } from 'react-i18next';
import FeelingChip from '@ui/components/FeelingChip/FeelingChip';
import styles from './FeelingsSection.module.css';

const JOURNAL_ENTRIES = [
  {
    technique: 'Nadi Shodhana · Alternate Nostril Breathing',
    date: 'Today',
    before: ['stressed'],
    after: ['calm', 'focused'],
  },
  {
    technique: 'Bhramari · Humming Bee Breath',
    date: 'Yesterday',
    before: ['anxious'],
    after: ['peaceful', 'relaxed'],
  },
  {
    technique: 'Kapalabhati · Skull Shining Breath',
    date: 'Apr 22',
    before: ['tired'],
    after: ['energized', 'clarity'],
  },
];

export default function FeelingsSection() {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.heading}>
          {t('feelings.heading')}
        </h2>
        <p className={styles.subtitle}>
          {t('feelings.subtitle')}
        </p>

        <div className={styles.columns}>
          {/* Journal card */}
          <div className={styles.journal}>
            <div className={styles.journalHeader}>{t('feelings.journalHeader')}</div>
            {JOURNAL_ENTRIES.map((entry) => (
              <div key={entry.technique} className={styles.entry}>
                <div className={styles.entryTop}>
                  <span className={styles.entryTechnique}>
                    {entry.technique}
                  </span>
                  <span className={styles.entryDate}>{entry.date}</span>
                </div>
                <div className={styles.entryFeelings}>
                  {entry.before.map((f) => (
                    <FeelingChip key={f} variant="before">{f}</FeelingChip>
                  ))}
                  <span className={styles.feelingArrow}>&rarr;</span>
                  {entry.after.map((f) => (
                    <FeelingChip key={f} variant="after">{f}</FeelingChip>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Insight card */}
          <div className={styles.insight}>
            <div className={styles.insightBadge}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 2a7 7 0 0 1 7 7c0 2.4-1.2 4.5-3 5.7V17a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2.3C6.2 13.5 5 11.4 5 9a7 7 0 0 1 7-7z" />
                <line x1="9" y1="21" x2="15" y2="21" />
              </svg>
              {t('feelings.insightBadge')}
            </div>
            <p className={styles.insightText}>
              {t('feelings.insightText')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
